import React from "react";
import ReactGA from "react-ga";
import { useDispatch, useSelector } from "react-redux";
import { animateScroll as scroll } from "react-scroll";
import { Button, Collapse, Container, ListGroupItem } from "reactstrap";
import styled, { css } from "styled-components";
import { setZoom, toggleInfoWindow } from "../../store/actions";
import { setCenter } from "../../store/mapStore";
import { ON_OFFER } from "../../types/offerStates";
import InfoTable from "./InfoTable";
import {
  selectRestaurantOfferState,
  selectRestaurantDiscountString
} from "../../store/restaurantsStore/offerSelectors";
import { selectRestaurantClosingTimes } from "../../store/restaurantsStore/selectors";

const RestaurantListGroupItem = ({
  children,
  className,
  id
}: {
  children: JSX.Element[] | JSX.Element;
  onOffer: boolean;
  className?: string;

  id: string;
}) => {
  return (
    <ListGroupItem className={className} id={id}>
      {children}
    </ListGroupItem>
  );
};

const ListItemContainer = styled(RestaurantListGroupItem)`
  background-color: white;
  color: black;
  ${({ onOffer }) =>
    onOffer &&
    css`
      background-color: green;
      color: white;
    `}
`;

const useCollapse = (restaurantKey: string): [boolean, () => void] => {
  const [collapse, setCollapse] = React.useState(false);
  const toggle = () => {
    setCollapse(!collapse);
    ReactGA.event({
      category: "List",
      action: "More Info",
      label: restaurantKey
    });
  };
  return [collapse, toggle];
};

const RestaurantListItem = ({
  restaurant
}: {
  restaurant: RestaurantFromAPI;
}) => {
  const onOffer =
    useSelector(selectRestaurantOfferState(restaurant._id)) === ON_OFFER;
  const dispatch = useDispatch();
  const [collapse, toggle] = useCollapse(restaurant.key);
  const onClickPanTo = () => {
    dispatch(setCenter({ lat: restaurant.lat, lng: restaurant.lng }));
    dispatch(setZoom(20));
    dispatch(toggleInfoWindow({ key: restaurant.key, open: true }));
    scroll.scrollToTop({ duration: 500, smooth: true });
    ReactGA.event({
      category: "List",
      action: "Show On Map",
      label: restaurant.key
    });
  };
  const discountString = useSelector(
    selectRestaurantDiscountString(restaurant._id)
  );
  const closingTimes = useSelector(
    selectRestaurantClosingTimes(restaurant._id)
  );
  return (
    <ListItemContainer onOffer={onOffer} id={restaurant.key}>
      <h1 style={{ fontSize: 4.5 + "vh" }}>
        {restaurant.name + " " + restaurant.address}
      </h1>
      <h2 style={{ fontSize: 3 + "vh" }}>{discountString}</h2>
      <div style={{ display: "inline-block", width: "100%" }}>
        <Button
          outline={!onOffer}
          color="primary"
          onClick={toggle}
          style={{ display: "inline-block", fontSize: "2.5vh" }}
        >
          More Info
        </Button>
        <Collapse
          style={{
            backgroundColor: "white",
            marginTop: 10,
            marginBottom: 10,
            borderRadius: 10
          }}
          isOpen={collapse}
        >
          <p style={{ marginLeft: 18 }}>{restaurant.longAddress}</p>
          <Container fluid={true} style={{ overflow: "auto" }}>
            <InfoTable closingTimes={closingTimes} />
          </Container>
        </Collapse>
        <button
          className="btn btn-primary"
          onClick={onClickPanTo}
          style={{
            float: "right",
            display: "inline-block",
            fontSize: "2.5vh"
          }}
        >
          Show Me
        </button>
      </div>
    </ListItemContainer>
  );
};

export default RestaurantListItem;
